import { ModuleName } from "../AxSystem/AxInit";
import { PriceHelper } from "./PriceHelper";

export interface ForeignCurrencyConfig {
    enabled: boolean;
    conversionFactor: number;
    currencyShortName: string;
    roundTo: number;
    roundTo5: boolean;
}
@ModuleName("ForeignCurrencyPriceHelper")
export class ForeignCurrencyPriceHelper {
    private config: ForeignCurrencyConfig;
    private priceHelper: PriceHelper;

    constructor(config: ForeignCurrencyConfig) {
        this.config = config;
        this.priceHelper = new PriceHelper(null, false);
    }

    isEnabled(): boolean {
        return this.config?.enabled === true && this.config.conversionFactor > 0;
    }

    convertPrice(priceInCent: number): number {
        let multiplier = 1 / this.config.conversionFactor;
        if (multiplier < 0) {
            multiplier = -1 / multiplier;
        }

        let converted = (priceInCent / 100) * multiplier;

        if (this.config.roundTo5) {
            converted = Math.round(converted * 20) / 20;
        } else if (this.config.roundTo > 0) {
            const factor = Math.pow(10, this.config.roundTo);
            converted = Math.round(converted * factor) / factor;
        } else {
            converted = Math.round(converted * 100) / 100;
        }

        return converted;
    }

    getForeignCurrencyHtml(priceInCent: number): string {
        if (!this.isEnabled()) {
            return '';
        }

        const converted = this.convertPrice(priceInCent);
        const formatted = this.priceHelper.GetPriceString(converted);

        return `<span class="price__frc">${this.config.currencyShortName} ${formatted}</span>`;
    }
}